var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.166 16.4C14.9451 16.4 14.766 16.2209 14.766 16V15H13.166V16C13.166 17.1046 14.0614 18 15.166 18H22.166C23.2706 18 24.166 17.1046 24.166 16V6C24.166 4.89543 23.2706 4 22.166 4H17.166L13.166 8V10H14.766V8.66274L17.8288 5.6H22.166C22.3869 5.6 22.566 5.77909 22.566 6V16C22.566 16.2209 22.3869 16.4 22.166 16.4H15.166ZM9.16602 18.4H2.16602C1.9451 18.4 1.76602 18.2209 1.76602 18V10.6627L4.82876 7.6H9.16602C9.38693 7.6 9.56602 7.77909 9.56602 8V10H11.166V8C11.166 6.89543 10.2706 6 9.16602 6H4.16602L0.166016 10V18C0.166016 19.1046 1.06145 20 2.16602 20H9.16602C10.2706 20 11.166 19.1046 11.166 18V15H9.56602V18C9.56602 18.2209 9.38693 18.4 9.16602 18.4ZM12.166 11.2946L7.16602 11.2946C6.61602 11.2946 6.16602 11.7446 6.16602 12.2946C6.16602 12.8446 6.61602 13.2946 7.16602 13.2946H12.166H14.166H16.166V15.0846C16.166 15.5346 16.706 15.7546 17.016 15.4346L19.806 12.6446C20.006 12.4446 20.006 12.1346 19.806 11.9346L17.016 9.14462C16.706 8.83462 16.166 9.05462 16.166 9.50462V11.2946H14.166H12.166Z",
    fill: "#111114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimChange);
export default __webpack_public_path__ + "static/media/sim_change.e306a9068149eb54854f5d4a896d18b9.svg";
export { ForwardRef as ReactComponent };